
// Article URL redirects data
// These are the URLs from Ahrefs that need to be redirected from /article/ to /blog/

export const articleRedirects = [
  {
    source_path: '/article/holiday-elf-working-parents-time-saving-tips',
    target_path: '/blog/holiday-elf-working-parents-time-saving-tips',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-teens-creative-ideas',
    target_path: '/blog/holiday-elf-teens-creative-ideas',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/christkind-tradition-modernized-elf-letter-bot',
    target_path: '/blog/christkind-tradition-modernized-elf-letter-bot',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/best-holiday-elf-response-letters-2025',
    target_path: '/blog/best-holiday-elf-response-letters-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-name-generator',
    target_path: '/elf-name-generator',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/creative-holiday-elf-arrival-ideas-2024',
    target_path: '/blog/creative-holiday-elf-arrival-ideas-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/german-christmas-traditions-family-guide-2025',
    target_path: '/blog/german-christmas-traditions-family-guide-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/creative-holiday-elf-arrival-ideas-2025',
    target_path: '/blog/creative-holiday-elf-arrival-ideas-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-ideas-planner',
    target_path: '/blog/creative-holiday-elf-arrival-ideas-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/hilarious-holiday-elf-pranks-ideas-2025',
    target_path: '/blog/hilarious-holiday-elf-pranks-ideas-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-coloring-pages-2024',
    target_path: '/blog/holiday-elf-coloring-pages-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/printable-holiday-elf-letterhead-templates-guide',
    target_path: '/blog/printable-holiday-elf-letterhead-templates-guide',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/ultimate-guide-magical-holiday-traditions-magical-elf-santa-letters',
    target_path: '/blog/ultimate-guide-magical-holiday-traditions-magical-elf-santa-letters',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-craft-generator-household-items',
    target_path: '/blog/holiday-elf-craft-generator-household-items',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/inclusive-holiday-elf-guide-special-needs-children',
    target_path: '/blog/inclusive-holiday-elf-guide-special-needs-children',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/diy-holiday-elf-accessories-easy-family-crafts',
    target_path: '/blog/diy-holiday-elf-accessories-easy-family-crafts',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/unique-personalized-holiday-elf-letter-ideas',
    target_path: '/blog/unique-personalized-holiday-elf-letter-ideas',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/hilarious-holiday-elf-pranks-ideas-2024',
    target_path: '/blog/hilarious-holiday-elf-pranks-ideas-2026',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-scene-spinner-generator',
    target_path: '/blog/holiday-elf-scene-spinner-generator',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/adapting-holiday-elf-autism-inclusive-guide',
    target_path: '/blog/adapting-holiday-elf-autism-inclusive-guide',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/multilingual-holiday-elf-adventures-bilingual-families',
    target_path: '/blog/multilingual-holiday-elf-adventures-bilingual-families',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/hilarious-holiday-elf-stories-setup-guide-2025',
    target_path: '/blog/hilarious-holiday-elf-stories-setup-guide-2025',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/year-round-holiday-elf-magic',
    target_path: '/blog/year-round-holiday-elf-magic',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/free-elf-arrival-letter-templates-2025',
    target_path: '/blog/free-elf-arrival-letter-templates-2025',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/christmas-eve-letters-from-santa-magical-guide',
    target_path: '/blog/christmas-eve-letters-from-santa-magical-guide',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-recipe-generator',
    target_path: '/blog/holiday-elf-recipe-generator',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/accidentally-touched-holiday-elf-restore-magic-guide',
    target_path: '/blog/accidentally-touched-holiday-elf-restore-magic-guide',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/last-minute-holiday-elf-ideas-household-items',
    target_path: '/blog/last-minute-holiday-elf-ideas-household-items',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/educational-holiday-elf-ideas-learning-through-letters',
    target_path: '/blog/educational-holiday-elf-ideas-learning-through-letters',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/holiday-elf-family-challenges-magical-holiday-adventures',
    target_path: '/blog/holiday-elf-family-challenges-magical-holiday-adventures',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/inclusive-holiday-elf-special-needs-children',
    target_path: '/blog/inclusive-holiday-elf-special-needs-children',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/best-personalized-elf-letters-holiday-season',
    target_path: '/blog/best-personalized-elf-letters-holiday-season',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/perfect-holiday-elf-letter-fonts',
    target_path: '/blog/perfect-holiday-elf-letter-fonts',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  {
    source_path: '/article/global-holiday-helper-traditions-magical-messages',
    target_path: '/blog/global-holiday-helper-traditions-magical-messages',
    status_code: 301,
    is_active: true,
    notes: 'Redirect article URL to blog URL'
  },
  // Handle API placeholder redirects to a generic placeholder or 404
  {
    source_path: '/api/placeholder/400/320',
    target_path: '/404',
    status_code: 404,
    is_active: true,
    notes: 'API placeholder should return 404'
  },
  {
    source_path: '/api/placeholder/800/400',
    target_path: '/404',
    status_code: 404,
    is_active: true,
    notes: 'API placeholder should return 404'
  }
];
